import React, { useContext, useState, useEffect } from "react";
import { Link, withRouter, Redirect } from "react-router-dom";
import axios from "axios";
import Pagination from "react-js-pagination";

import AuthContext from "../../context/AuthContext";
import useObtenerUsuario from "../../utils/useObtenerUsuario";

import TarjetaVoto from "../components/tarjetavoto";
import MPage from "../../components/templates/mpage";
import BusquedaVoto from "../components/busquedaVoto";
import LinkPrivado from "../components/linkprivado";

const Fiscalizar = (props) => {
  const { loggedIn } = useContext(AuthContext);
  const [usuario, errorUsuario] = useObtenerUsuario(loggedIn);
  const [municipio, guardarMunicipio] = useState(undefined);
  const [votos, guardarVotos] = useState(undefined);
  const [error, guardarError] = useState(false);

  // Paginación
  const votosPorPag = 10;
  const [pagActiva, guardarPaginaActiva] = useState(1);
  const indexUltimoVoto = pagActiva * votosPorPag;
  const indexPrimerVoto = indexUltimoVoto - votosPorPag;

  // Obtengo el municipio
  useEffect(() => {
    if (usuario !== undefined) {
      const obtenerMunicipio = () => {
        axios
          .get(`/api/municipios/${usuario.municipioId}`)
          .then((res) => {
            guardarMunicipio(res.data.municipio);
          })
          .catch((error) => guardarError(true));
      };
      obtenerMunicipio();
    }
    return () => {
      guardarMunicipio(undefined);
    };
  }, [usuario]);

  // Obtengo los votos
  useEffect(() => {
    if (municipio !== undefined) {
      const obtenerVotos = () => {
        axios
          .get(`/api/votos?municipioId=${municipio._id}`)
          .then((res) => {
            guardarVotos(res.data.votos);
          })
          .catch((error) => guardarError(true));
      };
      obtenerVotos();
    }
    return () => {
      guardarVotos(undefined);
    };
  }, [municipio]);

  // Maneja el cambio de página
  const handlePageChange = (numPagina) => {
    guardarPaginaActiva(numPagina);
  };

  // Actualiza el estado de un voto al ser anulado
  const actualizarVoto = (idVoto, razonAnulado) => {
    guardarVotos((prevVotos) =>
      prevVotos.map((voto) =>
        voto._id === idVoto
          ? { ...voto, anulado: true, razonAnulado } // Agrega razonAnulado
          : voto
      )
    );
  };

  if (loggedIn === false) return <Redirect to="/login" />;
  if (error === true || errorUsuario === true) return <Redirect to="/" />;
  if (usuario === undefined || municipio === undefined || votos === undefined)
    return null;
  if (usuario.editarVotacion === false) return <Redirect to="/consola" />;

  const votosActuales = votos.slice(indexPrimerVoto, indexUltimoVoto);

  const renderVotos = votosActuales.map((voto, indice) => {
    return (
      <TarjetaVoto
        key={indice}
        voto={voto}
        usuario={usuario}
        onAnular={actualizarVoto} // Pasar la función al hijo
      />
    );
  });

  return (
    <MPage municipio={municipio}>
      <div className="container adminp">
        <div className="row">
          <div className="col-md-12">
            <h3 className="ppr-titulo entrado my-2">Fiscalizar Votación</h3>
            <div>
              <div className="text-right">
                <LinkPrivado usuario={usuario}>Descargar Votos</LinkPrivado>
              </div>
              <center>
                <BusquedaVoto
                  municipio={municipio}
                  onActualizarVoto={actualizarVoto}
                />
              </center>
              <div className="pagination">
                <Pagination
                  activePage={pagActiva}
                  itemsCountPerPage={10}
                  totalItemsCount={votos.length}
                  pageRangeDisplayed={10}
                  onChange={handlePageChange}
                />
              </div>
              <div className="result">{renderVotos}</div>
            </div>
          </div>
        </div>
        <center>
          <Link
            to={"/consola"}
            className="btn ppr-btn-verde font-weight-bold m-2"
          >
            Volver
          </Link>
        </center>
      </div>
    </MPage>
  );
};

export default withRouter(Fiscalizar);
